import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components//Footer/footer";
import StepRoutes from "../../../Kryzen Alpha App/Routes/steps_routes";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import Pagination from "../../../Kryzen Alpha App/Components/layouts/pagination";
import getFilteredURL from "../../../Kryzen Alpha App/Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcPhone, FcStackOfPhotos } from "react-icons/fc";
import { useSelector } from "react-redux";
import GetAiVoiceTable from "./getaicallLogsTable";

const GetAiCallLogs = () => {
  let userData = useSelector((store) => store.login.user);
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    mobaile: "",
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [freshtotal, setFreshTotal] = useState([]);
  const [autoCallingEnabled, setAutoCallingEnabled] = useState(false);
  const [totComplate, setTotComplate] = useState();
  const [toggleLoading, setToggleLoading] = useState(false);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL(`/get-call/getaivoiceagentdata`, page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.aiVoiceData);
          setFreshTotal(res?.data?.freshEnquiries);
          setTotComplate(res?.data?.aiVoiceCount);
          setTotalPages(Math.ceil(res?.data?.aiVoiceCount / 50));
        } else {
          Toast("error", "Error while getting logs!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh, page]);

  const getAutoCallingStatus = async () => {
    try {
      const res = await performRequest("GET", "/get-call/getcallingstatus");

      if (res?.status === 200) {
        setAutoCallingEnabled(res?.data?.enabled);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleToggleAutoCalling = async () => {
    try {
      setToggleLoading(true);

      // ENABLE
      if (!autoCallingEnabled) {
        const res = await performRequest(
          "PATCH",
          "/get-call/enable-auto-calling"
        );

        if (res?.status === 200) {
          setAutoCallingEnabled(true);

          Toast("success", "Auto Calling Enabled");
        }
      }

      // DISABLE
      else {
        const res = await performRequest(
          "PATCH",
          "/get-call/disabled-auto-calling"
        );

        if (res?.status === 200) {
          setAutoCallingEnabled(false);

          Toast("success", "Auto Calling Disabled");
        }
      }
    } catch (error) {
      console.log(error);

      Toast("error", "Error while updating auto calling");
    } finally {
      setToggleLoading(false);
    }
  };

  useEffect(() => {
    getAutoCallingStatus();
  }, []);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                {/* LEFT */}

                <div className="col">
                  <h2 className="page-title">
                    <FcPhone className="fs-2 me-1" />
                    Ai Call Logs
                  </h2>

                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>

                {/* RIGHT */}

                <div className="col-auto">
                  <div
                    className="
        card
        px-3
        py-2
        d-flex
        flex-row
        align-items-center
        gap-3
      "
                  >
                    <div>
                      <div className="fw-bold">Auto Calling</div>

                      <small
                        className={
                          autoCallingEnabled ? "text-success" : "text-danger"
                        }
                      >
                        {autoCallingEnabled ? "Enabled" : "Disabled"}
                      </small>
                    </div>

                    {/* TOGGLE */}

                    <label className="form-check form-switch m-0">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={autoCallingEnabled}
                        onChange={handleToggleAutoCalling}
                        disabled={toggleLoading}
                      />
                    </label>

                    {/* LOADER */}

                    {toggleLoading && (
                      <div
                        className="spinner-border spinner-border-sm"
                        role="status"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                <div className="col-md-3 col-sm-12 py-2">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Contact Number"
                                  value={filters.mobaile}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      mobaile: e.target.value,
                                    })
                                  }
                                  type="text"
                                  placeholder="Search Contact Number"
                                />
                              </div>
                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          startdate: "",
                                          enddate: "",
                                          mobaile: "",
                                        });
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Contact Number"
                                value={filters.mobaile}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    mobaile: e.target.value,
                                  })
                                }
                                type="text"
                                placeholder="Search Contact Number"
                              />
                            </div>
                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        startdate: "",
                                        enddate: "",
                                        mobaile: "",
                                      });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div>
                    <p>Remaining Calls: {freshtotal}</p>
                  </div>
                  <div>
                    <p>Complated Calls: {freshtotal}</p>
                  </div> */}
                  <div className="row g-3 mb-3 mt-1">
                    <div className="col-md-6">
                      <div className="card border-warning shadow-sm ">
                        <div className="card-body text-center p-0">
                          <h1 className="fw-bold text-warning mb-0">
                            {freshtotal}
                          </h1>
                          <h6 className="text-muted mb-2">Remaining Calls</h6>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="card border-success shadow-sm h-100">
                        <div className="card-body text-center p-0">
                          <h1 className="fw-bold text-success mb-0">
                            {totComplate}
                          </h1>
                          <h6 className="text-muted mb-2">Completed Calls</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-sm-12 py-2">
                  <div className="card">
                    <GetAiVoiceTable
                      data={data}
                      currentPage={page}
                      itemsPerPage={50}
                    />
                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default GetAiCallLogs;
